import React from 'react';
import { FiX, FiDownload, FiMaximize2 } from 'react-icons/fi';

export default function MediaPreviewModal({ isOpen, onClose, src, title }) {
    if (!isOpen || !src) return null;

    return (
        <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-gray-900/90 backdrop-blur-md animate-in fade-in duration-300">
            <div className="relative w-full max-w-5xl h-full max-h-[90vh] flex flex-col bg-white rounded-3xl overflow-hidden shadow-2xl animate-in zoom-in-95 duration-300">
                {/* Header */}
                <div className="px-6 py-4 border-b border-gray-100 flex items-center justify-between bg-white shrink-0">
                    <div className="flex items-center gap-3">
                        <div className="w-10 h-10 bg-blue-50 rounded-xl flex items-center justify-center text-blue-600">
                            <FiMaximize2 size={20} />
                        </div>
                        <div>
                            <h3 className="text-lg font-bold text-gray-900 leading-none">{title || 'Media Preview'}</h3>
                            <p className="text-xs text-gray-500 mt-1 font-medium">Verify attachment details</p>
                        </div>
                    </div>
                    <div className="flex items-center gap-2">
                        <a
                            href={src}
                            download
                            target="_blank"
                            rel="noreferrer"
                            className="p-3 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded-xl transition-all"
                            title="Download / Open Full"
                        >
                            <FiDownload size={20} />
                        </a>
                        <button
                            onClick={onClose}
                            className="p-3 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-xl transition-all"
                            title="Close"
                        >
                            <FiX size={20} />
                        </button>
                    </div>
                </div>

                {/* Content */}
                <div className="flex-1 overflow-auto p-4 md:p-8 bg-gray-50 flex items-center justify-center">
                    <img
                        src={src}
                        alt={title}
                        className="max-w-full max-h-full object-contain rounded-xl shadow-lg border border-white"
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = 'https://placehold.co/600x400?text=Failed+to+load+image';
                        }}
                    />
                </div>
            </div>

            {/* Backdrop click to close */}
            <div className="absolute inset-0 -z-10" onClick={onClose}></div>
        </div>
    );
}
